<template>
    <form class="bg-white w-100 message-form" autocomplete="off"
          v-if="roles[0].name !== roleService.ADMIN || (roles.map(val => val.name).includes(roleService.ADMIN) && senderId === userId)"
          @submit.prevent="submit($event)">

        <div class="conclusion p-3">
            <div class="attachments d-flex justify-content-start flex-wrap">
                <div class="position-relative me-3 mb-3" v-for="(image, index) in files">
                    <div
                        class="d-flex position-absolute w-100 h-100 top-0 left-0 justify-content-center align-items-center">
                        <button type="button" class="btn btn-sm btn-delete btn-secondary  btn-icon" v-on:click="files.splice(index, 1)">
                            <i class="fs-16 fi fi-rr-trash"></i>
                        </button>
                    </div>
                    <img class="border-radius-10" :src="toUrl(image)" height="70" width="70"
                         alt="Img" style="object-fit: cover;">
                </div>
            </div>
            <textarea v-model="text" @focus="focusOnAIInput" :placeholder="trans('general.page.messages.message')"
                      type="text" ref="message" class="ai-input form-control" id="message" name="message"></textarea>

            <div class="row">
                <span>
                    <input class="d-none" id="chooseImages" type="file" accept="image/*"
                           v-on:change="selectedImages($event)" multiple/>
                    <input class="d-none" id="captureImage" type="file" accept="image/*"
                           v-on:change="selectedImages($event)" capture="camera"/>
                </span>

                <div class="col-12 d-flex justify-content-between">
                    <div class="icons d-flex align-items-center gap-4">
                        <div class="icon" onclick="document.getElementById('chooseImages').click()" type="button">
                            <i class="icon fi fi-rr-picture"></i>
                        </div>
                        <div class="icon" onclick="document.getElementById('captureImage').click()" type="button">
                            <i class="icon fi fi-rr-camera"></i>
                        </div>
                        <a-i-button
                            icon="fi-rr-text-check"
                            :disabled="text.length === 0 || generatingAI"
                            :generating="generatingAICorrection"
                            :text="trans('general.ai.correct_text')"
                            v-on:click="text.length > 0 ? correctText() : null"/>
                    </div>

                    <basic-button
                        cls="btn btn-sm btn-submit btn-secondary  btn-icon px-2"
                        type="submit"
                        ref="submitBtn"
                        :disabled="submitBtnDisabled">
                        <v-wait for='send-message' class="icon" v-if="$wait.is('send-message')">
                            <HalfCircleSpinner slot='waiting' :size="24" :color="'#503E9D'"/>
                        </v-wait>
                        <i v-if="!$wait.is('send-message')"  class="fi fi-rr-paper-plane"> </i>
                        <span class="d-none d-lg-inline-block">{{ trans('general.defaults.send') }}</span>
                    </basic-button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import RoleService from "../../../services/RoleService";
import { HalfCircleSpinner } from 'epic-spinners'
import AIButton from "../../../theme/atoms/AIButton.vue";
import {adjustHeight, focusOnAIInput, startTyping} from "../../../services/AI";
import BasicButton from "../../../theme/atoms/BasicButton.vue";

export default {
    name: "MessageForm",
    props: {users: Array, childId: Number, userId: Number, senderId: Number, receiverId: Number, roles: Array},
    data() {
        return {
            files: [],
            roleService: RoleService,
            text: '',

            generatingAI: false,
            generatingAICorrection: false,
            typingInterval: null,
            typingIndex: 0,
            submitBtnDisabled: false,
        }
    },
    components: {
        BasicButton,
        AIButton,
      HalfCircleSpinner
    },

    computed: {
        rowsNum: function () {
            let rows = this.text.length > 22 ? parseInt(this.text.length) / 22 : 1;
            return rows < 4 ? rows : 4;
        }
    },

    methods: {
        focusOnAIInput,

        toUrl(image) {
            return URL.createObjectURL(image)
        },
        submit(event) {
            this.$wait.start('send-message');
            this.errors = [];
            let form = new FormData(event.target);
            form.append('receiver_id', this.receiverId.toString());

            if(this.childId)
                form.append('child_id', this.childId.toString());

            this.users.forEach(val => form.append('participants[]', val.id))

            this.files.forEach(file => {form.append('images[]', file)})
            this.submitBtnDisabled = true

            axios.post(`/messages/new`, form, {headers: {'content-type': 'multipart/form-data'}})
                .then(response => {
                    this.$emit('message-sent', response.data.data)
                    this.submitBtnDisabled = false

                    this.$wait.end('send-message');
                    event.target.reset();
                    this.files = [];
                    this.text = '';
                })
                .catch(error => {
                  this.$wait.end('send-message');
                  this.submitBtnDisabled = false

                    if (error.response.data.message === '' && error.response.data.errors) {
                        let errors = Object.values(error.response.data.errors);
                        this.errors = errors.map(val => val[0] || 0)
                    } else {
                        this.$notify({type: 'error', text: error.response.data.message});
                    }
                })
        },

        selectedImages(event) {
            for (let file of event.target.files) {
                this.files.push(file)
            }
        },

        correctText() {
            if(! this.generatingAI) {
                this.generatingAI = true;
                this.generatingAICorrection = true;

                const prompt = `Please apply correction to the text in the written language and return just the result. Here is the text: ${this.text}.`;

                axios.post('/general-ai/manipulate-text', {prompt, type: 'correction'})
                    .then(response => {
                        this.generatingAICorrection = false;
                        this.generatingAI = false;
                        this.setAdditionalText(response.data.data);
                    })
                    .catch(error => {
                        this.$notify({type: 'error', text: trans('general.ai.error_correcting_text')});
                        this.generatingAICorrection = false;
                        this.generatingAI = false;
                    })
            }
        },

        startTypingAI(text, ref) {
            startTyping(text, (value) => {
                this.text = value;
            }, () => adjustHeight(ref));
        },

        setAdditionalText(text) {
            this.text = '';
            this.startTypingAI(text, null);
        }
    }
}
</script>

<style scoped>
.message-box {
    min-height: 58px !important;
    padding-right: 80px;
}
.input-buttons {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
}
</style>
